import { render, staticRenderFns } from "./ChildProtectionPolicy.vue?vue&type=template&id=efcf1cd4&scoped=true"
import script from "./ChildProtectionPolicy.vue?vue&type=script&lang=js"
export * from "./ChildProtectionPolicy.vue?vue&type=script&lang=js"
import style0 from "./ChildProtectionPolicy.vue?vue&type=style&index=0&id=efcf1cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcf1cd4",
  null
  
)

export default component.exports